import { requestJson } from "./apiClient";

export async function listCultureAdminSources() {
  return requestJson("/api/admin/culture/sources");
}

export async function getCultureSourceReadiness(sourceKey) {
  return requestJson(
    `/api/admin/culture/sources/${encodeURIComponent(sourceKey)}/ingestion/readiness`
  );
}

export async function runCultureSource(sourceKey, options = {}) {
  return requestJson(
    `/api/admin/culture/sources/${encodeURIComponent(sourceKey)}/ingestion/run`,
    {
      method: "POST",
      body: JSON.stringify({
        dryRun: options.dryRun === true,
        apply: options.apply === true,
        force: Boolean(options.force),
        limit: options.limit,
        maxPages: options.maxPages,
        enrichDetails: options.enrichDetails,
        matchVenues: options.matchVenues,
        dedupe: options.dedupe,
        inferTags: options.inferTags,
      }),
    }
  );
}

export async function getCultureSourceHealth(sourceKey) {
  return requestJson(
    `/api/admin/culture/sources/${encodeURIComponent(sourceKey)}/health`
  );
}

export async function updateCultureSource(sourceKey, patch) {
  const response = await requestJson(
    `/api/admin/culture/sources/${encodeURIComponent(sourceKey)}`,
    {
      method: "PATCH",
      body: JSON.stringify(patch),
    }
  );
  return response.source || response;
}

export async function listCultureSourceRuns(sourceKey, filters = {}) {
  const params = new URLSearchParams();
  if (filters.limit != null) {
    params.set("limit", String(filters.limit));
  }
  const query = params.toString();
  return requestJson(
    `/api/admin/culture/sources/${encodeURIComponent(sourceKey)}/runs${query ? `?${query}` : ""}`
  );
}

export function parseCultureControlsApiError(error) {
  const payload = error?.payload || error?.body || {};
  return {
    message: payload.message || error?.message || "Culture source request failed.",
    blockingReasons: payload.blockingReasons || [],
    code: payload.error || null,
  };
}
